
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProcedureApi } from '../api/procedure.api';
import { switchMap, map } from 'rxjs/operators';

import { ProcedureData, Procedure } from '../../../interfaces/masters/procedure' ;
@Injectable()
export class ProcedureService extends ProcedureData {

    constructor(private api: ProcedureApi) {
      super();
    }
  
    list(url: string): Observable<Procedure[]> {
      return this.api.list(url);
    }
  
  
    getById(url:string): Observable<Procedure>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Procedure): Observable<Procedure[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Procedure): Observable<Procedure> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  
